module.exports = [
	{
		"wwfurl": "http://wwf.panda.org",
		"name": "WWF Global"
	},
	{
		"wwfurl": "http://www.vidasilvestre.org.ar",
		"name": "Argentina"
	},
	{
		"wwfurl": "http://armenia.panda.org",
		"name": "Armenia"
	},
	{
		"wwfurl": "http://www.wwf.at",
		"name": "Austria"
	},
	{
		"wwfurl": "",
		"name": "Australia"
	},
	{
		"wwfurl": "http://www.wwf.be",
		"name": "Belgium"
	},
	{
		"wwfurl": "http://www.wwfbhutan.org",
		"name": "Bhutan"
	},
	{
		"wwfurl": "http://bolivia.panda.org",
		"name": "Bolivia"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/borneo_forests",
		"name": "Borneo"
	},
	{
		"wwfurl": "http://www.wwf.org.br",
		"name": "Brasil"
	},
	{
		"wwfurl": "http://www.wwf.bg",
		"name": "Bulgaria"
	},
	{
		"wwfurl": "http://cambodia.panda.org",
		"name": "Cambodia"
	},
	{
		"wwfurl": "http://www.wwf.ca",
		"name": "Canada"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/black_sea_basin/caucasus",
		"name": "Caucasus"
	},
	{
		"wwfurl": "http://www.wwfca.org",
		"name": "Central America"
	},
	{
		"wwfurl": "http://chile.panda.org",
		"name": "Chile"
	},
	{
		"wwfurl": "http://en.wwfchina.org",
		"name": "China"
	},
	{
		"wwfurl": "http://www.wwf.org.co",
		"name": "Colombia"
	},
	{
		"wwfurl": "http://croatia.panda.org",
		"name": "Croatia"
	},
	{
		"wwfurl": "http://www.wwf.dk",
		"name": "Denmark"
	},
	{
		"wwfurl": "http://www.wwf.org.ec",
		"name": "Ecuador"
	},
	{
		"wwfurl": "http://www.wwf.eu",
		"name": "European Policy Office"
	},
	{
		"wwfurl": "http://www.wwf.fi",
		"name": "Finland"
	},
	{
		"wwfurl": "http://www.wwf.fr",
		"name": "France"
	},
	{
		"wwfurl": "http://www.wwf.de",
		"name": "Germany"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/project/projects_in_depth/mekong_river",
		"name": "Greater Mekong"
	},
	{
		"wwfurl": "http://www.wwf.gr",
		"name": "Greece"
	},
	{
		"wwfurl": "http://www.wwfguianas.org",
		"name": "Guianas"
	},
	{
		"wwfurl": "http://www.wwf.org.hk",
		"name": "Hong Kong"
	},
	{
		"wwfurl": "http://www.wwf.hu",
		"name": "Hungary"
	},
	{
		"wwfurl": "http://www.wwfindia.org",
		"name": "India"
	},
	{
		"wwfurl": "http://www.wwf.or.id",
		"name": "Indonesia"
	},
	{
		"wwfurl": "http://www.wwf.it",
		"name": "Italy"
	},
	{
		"wwfurl": "http://www.wwf.or.jp",
		"name": "Japan"
	},
	{
		"wwfurl": "http://wwfkorea.or.kr",
		"name": "Korea"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/laos",
		"name": "Laos"
	},
	{
		"wwfurl": "http://www.wwf.mg",
		"name": "Madagascar"
	},
	{
		"wwfurl": "http://www.wwf.org.my",
		"name": "Malaysia"
	},
	{
		"wwfurl": "http://mediterranean.panda.org",
		"name": "Mediterranean"
	},
	{
		"wwfurl": "http://www.wwf.org.mx",
		"name": "Mexico"
	},
	{
		"wwfurl": "http://mongolia.panda.org",
		"name": "Mongolia"
	},
	{
		"wwfurl": "http://www.wwf.org.mz",
		"name": "Mozambique"
	},
	{
		"wwfurl": "http://nepal.panda.org",
		"name": "Nepal"
	},
	{
		"wwfurl": "http://www.wnf.nl",
		"name": "Netherlands"
	},
	{
		"wwfurl": "http://www.wwf.org.nz",
		"name": "New Zealand"
	},
	{
		"wwfurl": "http://www.wwf.no",
		"name": "Norway"
	},
	{
		"wwfurl": "http://www.wwfpak.org",
		"name": "Pakistan"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/papua_new_guinea",
		"name": "Papua New Guinea"
	},
	{
		"wwfurl": "http://www.wwf.org.py",
		"name": "Paraguay"
	},
	{
		"wwfurl": "http://peru.panda.org",
		"name": "Peru"
	},
	{
		"wwfurl": "http://www.wwf.org.ph",
		"name": "Philippines"
	},
	{
		"wwfurl": "http://www.wwf.pl",
		"name": "Poland"
	},
	{
		"wwfurl": "http://www.wwf.pt",
		"name": "Portugal"
	},
	{
		"wwfurl": "http://romania.panda.org",
		"name": "Romania"
	},
	{
		"wwfurl": "http://www.wwf.ru",
		"name": "Russia"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/senegal",
		"name": "Senegal"
	},
	{
		"wwfurl": "http://www.panda.org/sr",
		"name": "Serbia"
	},
	{
		"wwfurl": "http://www.wwf.sg",
		"name": "Singapore"
	},
	{
		"wwfurl": "http://www.wwf.org.za",
		"name": "South Africa"
	},
	{
		"wwfurl": "http://www.wwfpacific.org",
		"name": "South Pacific"
	},
	{
		"wwfurl": "http://www.wwf.es",
		"name": "Spain"
	},
	{
		"wwfurl": "http://www.wwfguianas.org",
		"name": "Suriname"
	},
	{
		"wwfurl": "http://www.wwf.se",
		"name": "Sweden"
	},
	{
		"wwfurl": "http://www.wwf.ch",
		"name": "Switzerland"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/tanzania",
		"name": "Tanzania"
	},
	{
		"wwfurl": "http://www.wwf.or.th",
		"name": "Thailand"
	},
	{
		"wwfurl": "http://www.wwf.org.tr",
		"name": "Turkey"
	},
	{
		"wwfurl": "http://www.panda.org/uk",
		"name": "Ukraine"
	},
	{
		"wwfurl": "http://uae.panda.org",
		"name": "United Arab Emirates"
	},
	{
		"wwfurl": "http://www.wwf.org.uk",
		"name": "United Kingdom"
	},
	{
		"wwfurl": "http://www.worldwildlife.org",
		"name": "United States"
	},
	{
		"wwfurl": "http://vietnam.panda.org",
		"name": "Vietnam"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/store/countriesForMenu.json
// module id = 740
// module chunks = 0